import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'triggered-popover',
  templateUrl: './popover.component.html',
  styleUrls: ['./popover.component.scss']
})
export class PopoverComponent implements OnInit {

  @Input() icon: string;

  constructor() { }

  ngOnInit(): void {
  }

}
